export interface IFormFieldSaveBind {
  fieldId: string;
  value:
    | string
    | number
    | boolean
    | File
    | Date
    | '###NOT_APPLICABLE###'
    | null;
}

export class FormFieldSaveBind implements IFormFieldSaveBind {
  fieldId: string;
  value:
    | string
    | number
    | boolean
    | File
    | Date
    | '###NOT_APPLICABLE###'
    | null;

  constructor();
  constructor(obj: IFormFieldSaveBind);
  constructor(obj?: IFormFieldSaveBind) {
    this.fieldId = obj?.fieldId ?? '';
    this.value = obj?.value ?? '';
  }
}
